import x43 from '../../../images/Suikoden/Sonya108Glitchless/x43.png';
import x44 from '../../../images/Suikoden/Sonya108Glitchless/x44.png';
import x45 from '../../../images/Suikoden/Sonya108Glitchless/x45.png';
import x46 from '../../../images/Suikoden/Sonya108Glitchless/x46.png';
import x47 from '../../../images/Suikoden/Sonya108Glitchless/x47.png';
import x48 from '../../../images/Suikoden/Sonya108Glitchless/x48.png';
import x49 from '../../../images/Suikoden/Sonya108Glitchless/x49.png';
import x4a from '../../../images/Suikoden/Sonya108Glitchless/x4a.png';
import x4b from '../../../images/Suikoden/Sonya108Glitchless/x4b.png';
import x4c from '../../../images/Suikoden/Sonya108Glitchless/x4c.png';
import x4d from '../../../images/Suikoden/Sonya108Glitchless/x4d.png';
import x4e from '../../../images/Suikoden/Sonya108Glitchless/x4e.png';
import x4f from '../../../images/Suikoden/Sonya108Glitchless/x4f.png';
import x50 from '../../../images/Suikoden/Sonya108Glitchless/x50.png';
import x51 from '../../../images/Suikoden/Sonya108Glitchless/x51.png';
import x52 from '../../../images/Suikoden/Sonya108Glitchless/x52.png';
import x53 from '../../../images/Suikoden/Sonya108Glitchless/x53.png';
import x54 from '../../../images/Suikoden/Sonya108Glitchless/x54.png';
import x55 from '../../../images/Suikoden/Sonya108Glitchless/x55.png';
import x56 from '../../../images/Suikoden/Sonya108Glitchless/x56.png';
import x57 from '../../../images/Suikoden/Sonya108Glitchless/x57.png';
import x58 from '../../../images/Suikoden/Sonya108Glitchless/x58.png';
import x59 from '../../../images/Suikoden/Sonya108Glitchless/x59.png';
import x5a from '../../../images/Suikoden/Sonya108Glitchless/x5a.png';
import x5b from '../../../images/Suikoden/Sonya108Glitchless/x5b.png';
import x5c from '../../../images/Suikoden/Sonya108Glitchless/x5c.png';
import x5d from '../../../images/Suikoden/Sonya108Glitchless/x5d.png';
import x5e from '../../../images/Suikoden/Sonya108Glitchless/x5e.png';
import x5f from '../../../images/Suikoden/Sonya108Glitchless/x5f.png';

export default [
  {
    image: x43,
    additionalInfo: [],
    seed: '0x43',
    main: {
      vertical: 'Bottom',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Left'
    }
  },
  {
    image: x44,
    additionalInfo: [ 'Hard to See' ],
    seed: '0x44',
    main: {
      vertical: 'Middle',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Right'
    }
  },
  {
    image: x45,
    additionalInfo: [],
    seed: '0x45',
    main: {
      vertical: 'Middle',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Middle',
      horizontal: 'Left'
    }
  },
  {
    image: x46,
    additionalInfo: [],
    seed: '0x46',
    main: {
      vertical: 'Top',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Right'
    }
  },
  {
    image: x47,
    additionalInfo: [],
    seed: '0x47',
    main: {
      vertical: 'Bottom',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Left'
    }
  },
  {
    image: x48,
    additionalInfo: [],
    seed: '0x48',
    main: {
      vertical: 'Bottom',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Middle',
      horizontal: 'Right'
    }
  },
  {
    image: x49,
    additionalInfo: [],
    seed: '0x49',
    main: {
      vertical: 'Bottom',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Left'
    }
  },
  {
    image: x4a,
    additionalInfo: [],
    seed: '0x4a',
    main: {
      vertical: 'Middle',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Right'
    }
  },
  {
    image: x4b,
    additionalInfo: [ 'Hard to See' ],
    seed: '0x4b',
    main: {
      vertical: 'Top',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Middle',
      horizontal: 'Middle'
    }
  },
  {
    image: x4c,
    additionalInfo: [],
    seed: '0x4c',
    main: {
      vertical: 'Bottom',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Middle',
      horizontal: 'Right'
    }
  },
  {
    image: x4d,
    additionalInfo: [],
    seed: '0x4d',
    main: {
      vertical: 'Bottom',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Middle',
      horizontal: 'Middle'
    }
  },
  {
    image: x4e,
    additionalInfo: [ 'Hard to See' ],
    seed: '0x4e',
    main: {
      vertical: 'Middle',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Right'
    }
  },
  {
    image: x4f,
    additionalInfo: [],
    seed: '0x4f',
    main: {
      vertical: 'Middle',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Right'
    }
  },
  {
    image: x50,
    additionalInfo: [ 'Hard to See?' ],
    seed: '0x50',
    main: {
      vertical: 'Top',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Left'
    }
  },
  {
    image: x51,
    additionalInfo: [],
    seed: '0x51',
    main: {
      vertical: 'Bottom',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Middle',
      horizontal: 'Right'
    }
  },
  {
    image: x52,
    additionalInfo: [],
    seed: '0x52',
    main: {
      vertical: 'Bottom',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Left'
    }
  },
  {
    image: x53,
    additionalInfo: [],
    seed: '0x53',
    main: {
      vertical: 'Middle',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Right'
    }
  },
  {
    image: x54,
    additionalInfo: [],
    seed: '0x54',
    main: {
      vertical: 'Middle',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Left'
    }
  },
  {
    image: x55,
    additionalInfo: [ 'Hard to See?' ],
    seed: '0x55',
    main: {
      vertical: 'Top',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Middle',
      horizontal: 'Right'
    }
  },
  {
    image: x56,
    additionalInfo: [],
    seed: '0x56',
    main: {
      vertical: 'Bottom',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Middle'
    }
  },
  {
    image: x57,
    additionalInfo: [],
    seed: '0x57',
    main: {
      vertical: 'Bottom',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Right'
    }
  },
  {
    image: x58,
    additionalInfo: [],
    seed: '0x58',
    main: {
      vertical: 'Bottom',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Left'
    }
  },
  {
    image: x59,
    additionalInfo: [ 'Hard to See' ],
    seed: '0x59',
    main: {
      vertical: 'Middle',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Right'
    }
  },
  {
    image: x5a,
    additionalInfo: [],
    seed: '0x5a',
    main: {
      vertical: 'Top',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Left'
    }
  },
  {
    image: x5b,
    additionalInfo: [],
    seed: '0x5b',
    main: {
      vertical: 'Bottom',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Right'
    }
  },
  {
    image: x5c,
    additionalInfo: [],
    seed: '0x5c',
    main: {
      vertical: 'Bottom',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Middle'
    }
  },
  {
    image: x5d,
    additionalInfo: [ 'Empty Middle Left' ],
    seed: '0x5d',
    main: {
      vertical: 'Middle',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Left'
    }
  },
  {
    image: x5e,
    additionalInfo: [ 'Hard to See?' ],
    seed: '0x5e',
    main: {
      vertical: 'Middle',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Middle'
    }
  },
  {
    image: x5f,
    additionalInfo: [],
    seed: '0x5f',
    main: {
      vertical: 'Top',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Left'
    }
  }
]
